import { Core } from "@faire/slate/foundation/color";
import { Opacity } from "@faire/web/slate/Color";
import { Family } from "@faire/web/slate/Font";
import { Row } from "@faire/web/slate/Layout";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { TypographyStyles } from "@faire/web/slate/Typography";
import ClickOutside from "@faire/web/ui/ClickOutside";
import styled, { css } from "styled-components";

export const CancelButton = styled.button`
  ${TypographyStyles({ as: undefined })}
  margin: 0;
  background: none;
  padding: 4px 8px 4px 1px;
  border: 0;
  cursor: pointer;
  outline: 0;

  ${responsiveMediaQueries.mobile} {
    padding: 4px 16px 4px 1px;
  }
`;

export const TopSearchWrapper = styled(ClickOutside)<{
  $tabletFullWidth?: boolean;
}>`
  font-family: ${Family.sansSerif};
  display: flex;
  flex-direction: row;
  align-items: center;
  background: white;
  ${responsiveMediaQueries.tablet} {
    ${(props) =>
      props.$tabletFullWidth
        ? css`
            flex: 1;
          `
        : css`
            width: 400px;
          `}
  }
`;

export const TopSearchComponent = styled(Row).attrs({
  justify: "space-between",
})<{
  $isSearchVisible?: boolean;
  $isMultimodal?: boolean;
}>`
  height: ${(props) => (props.$isMultimodal ? "48px" : "40px")};
  border-radius: ${(props) => (props.$isMultimodal ? "16px" : "100px")};
  border: 1px solid ${Core.border.subdued};
  background-color: ${Core.surface.tertiary + Opacity.O_60};
  transition: border 120ms ease-out;

  &.expanded {
    border: 1px solid ${Core.border.subdued};
    background-color: ${Core.surface.primary};
  }
  width: 100%;
  font-family: ${Family.sansSerif};

  ${responsiveMediaQueries.mobile} {
    ${(props) =>
      props.$isSearchVisible
        ? css`
            margin: 12px 8px 12px 16px;
          `
        : css`
            margin: 12px 16px 12px 16px;
          `}
  }
`;

export const IconWrapper = styled(Row).attrs({ align: "center" })<{
  $padding: string;
}>`
  padding: ${(props) => props.$padding};
  background: none;
  border: 0;
  cursor: pointer;
  outline: 0;
`;
